<div class="tile-grid mt-3 scrollbar-styled-larger" [ngClass]="{ scrollContainer: filteredRequests.length > 18 }" #scrollContainer (scroll)="showMoreConsults($event)">
  @if (submitRequest) {
    <div class="request fake" [routerLink]="['/request']">
      <span>
        <mat-icon>add</mat-icon>
        <label>{{ "COMPONENTS.DASHBOARD.NEW_ENERGY_CONSULT" | translate }}</label>
      </span>
    </div>
  }
  @for (i of showRequests; track trackByECId($index, i)) {
    <div class="tile">
      <app-energy-consult [coaches]="coaches()" [requestStates]="requestStates()" (initRequests)="ngAfterContentInit()" [energyConsult]="i" [actions]="0"></app-energy-consult>
      <!-- /* [actions]="applicationService.session.user!.status === 'PendingDeleted' ? 2 : 0" */ -->
    </div>
  }
</div>
